module.exports = __webpack_public_path__ + "static/media/node-js.f96ac8e5.svg";